import { el, setChildren } from 'redom';

class Tooltip {

  constructor(target, tooltipMessageClass = '', tooltipMessage) {
    this.target = target;
    this.message = el(`div.tooltip-message${tooltipMessageClass}`, tooltipMessage);

    this.el = el('div.tooltip-container', [this.target, this.message]);

  }

  update(options) {

    this.target = options.target;
    this.message.textContent = options.message;

    setChildren(this.el, [this.target, this.message]);

  }

}

export default Tooltip;